import type { OrderStatus } from '@/bindings/OrderStatus'

/** The queue's filterable set, in state-machine order (T16: exactly these four are active). */
export const ACTIVE_STATUSES: readonly OrderStatus[] = ['sent', 'confirmed', 'processing', 'ready']

const STORAGE_KEY = 'romi.queue.statuses'

/** Which statuses this device shows (PRD); everything active until chosen, or when the choice is unusable. */
export function readQueueFilter(): OrderStatus[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed: unknown = raw ? JSON.parse(raw) : null
    if (!Array.isArray(parsed)) return [...ACTIVE_STATUSES]
    const chosen = ACTIVE_STATUSES.filter((status) => parsed.includes(status))
    return chosen.length > 0 ? chosen : [...ACTIVE_STATUSES]
  } catch {
    return [...ACTIVE_STATUSES]
  }
}

export function writeQueueFilter(statuses: readonly OrderStatus[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(statuses))
  } catch {
    // Storage blocked: the choice lasts for the page only.
  }
}

/** Flips one status; the last one showing stays (an empty queue filter shows nothing useful). */
export function toggleQueueStatus(statuses: readonly OrderStatus[], status: OrderStatus): OrderStatus[] {
  if (statuses.includes(status)) {
    return statuses.length === 1 ? [...statuses] : statuses.filter((s) => s !== status)
  }
  return ACTIVE_STATUSES.filter((s) => s === status || statuses.includes(s))
}
